export default {"src":"/_next/static/media/5.85b95bfa.svg","height":140,"width":122,"blurWidth":0,"blurHeight":0};